import { useEffect } from "react";
import Navbar from "../components/Navbar";
import OrderingMenu from "../components/OrderingMenu";
import Footer from "../components/Footer";
import { BRAND } from "../data/restaurant";

export default function MenuPage() {
  useEffect(() => {
    document.title = `Full Menu — ${BRAND.name}`;
  }, []);

  return (
    <div data-testid="menu-page" className="min-h-screen bg-cream">
      <Navbar />
      <main>
        <OrderingMenu />
      </main>
      <Footer />
    </div>
  );
}
